import axios from "axios";
import { TourData } from "../../Types";
import { useJWTStore } from "../Zustand";

const BASE_URL = "https://api.deepreality.cloud/api/";

export const axiosInstance = axios.create({ baseURL: BASE_URL });

export const previousTourData: TourData[] = [];

//WIP
//WIP
//WIP
export let token: string | null = null;

async function requireToken() {
  const resp = await axios.post(
    process.env.REACT_APP_TOKEN_ENDPOINT!,

    {
      grant_type: "client_credentials",
    },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },

      auth: {
        username: process.env.REACT_APP_CLIENT_ID!,
        password: process.env.REACT_APP_CLIENT_SECRET!,
      },
    }
  );

  return resp.data;
}

axiosInstance.interceptors.request.use(
  async (config) => {
    if (!token) {
      const fetchedToken = await requireToken();

      token = fetchedToken.access_token;
    }

    const jwtToken = useJWTStore.getState().jwt


    if (jwtToken) {
      config.headers.set("DeepRealityJwt", jwtToken);
    }

    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  async (err) => {
    throw err;
  }
);

axiosInstance.interceptors.response.use(
  (data) => {
    return data;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      (!error.response ||
        error.response.status === 403 ||
        error.response.status === 401) &&
      token &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const fetchedToken = await requireToken();

      token = fetchedToken.access_token;

      error.config.headers.Authorization = `Bearer ${token}`;

      return axiosInstance(originalRequest);
    }
    throw error;
  }
);
